"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var BaseCollectionQuery_1 = require("./BaseCollectionQuery");
var Query_1 = require("./Query");
var CoursesQuery = /** @class */ (function (_super) {
    __extends(CoursesQuery, _super);
    function CoursesQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoursesQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    CoursesQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, code = _a.code, codeQuery = _a.codeQuery, key = _a.key, keyQuery = _a.keyQuery, collectionItemConditional = _a.collectionItemConditional, sort = _a.sort, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ code: code,
            codeQuery: codeQuery,
            key: key,
            keyQuery: keyQuery,
            collectionItemConditional: collectionItemConditional,
            sort: sort }, (options.courses || {}));
    };
    CoursesQuery.prototype.getRawValue = function (executionOptions) {
        var _this = this;
        var sort = this.options.sort;
        var courses = this.getCourses(executionOptions);
        if (sort) {
            courses = this.applySort(courses, sort, undefined, executionOptions.inputs);
        }
        return courses && courses.map(function (course) { return _this.getCourseResult(executionOptions, course); });
    };
    CoursesQuery.prototype.getCourses = function (executionOptions) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options, code = _a.code, _b = _a.collectionItemConditional, collectionItemConditional = _b === void 0 ? { conditions: [] } : _b;
        if (code && !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'code'; })) {
            collectionItemConditional.conditions.push({
                field: 'code',
                operator: '=',
                value: code,
            });
        }
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        var collectionItems = context.courses
            .filter(function (item) { return conditionalHelper.matches(item, collectionItemConditional, executionOptions); });
        return collectionItems;
    };
    CoursesQuery.prototype.getCourseResult = function (executionOptions, course) {
        var key = this.options.key;
        return this.getCourseValue(executionOptions, course, key);
    };
    CoursesQuery.prototype.getCourseValue = function (executionOptions, course, key) {
        if (key === void 0) { key = null; }
        if (course) {
            if (key) {
                return course[key];
            }
            return course;
        }
        return;
    };
    return CoursesQuery;
}(BaseCollectionQuery_1.BaseCollectionQuery));
exports.CoursesQuery = CoursesQuery;
//# sourceMappingURL=CoursesQuery.js.map